"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.spinner = exports.container = exports.toastHide = exports.toastShow = void 0;

var react_1 = require("@emotion/react");

exports.toastShow = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  visibility: visible;\n  opacity: 1;\n  transform: translateY(0);\n"])));
exports.toastHide = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  visibility: hidden;\n  opacity: 0;\n  transform: translateY(-4px);\n"])));
var colorStyles = {
  success: react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    background-color: var(--green-400);\n  "]))),
  warning: react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    background-color: var(--yellow-700);\n  "]))),
  general: react_1.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    background-color: var(--gray-600);\n  "]))),
  error: react_1.css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    background-color: var(--red-500);\n  "])))
};
var positionStyles = {
  bottom: react_1.css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    left: 50%;\n    bottom: 16px;\n    transform: translateX(-50%) !important;\n  "]))),
  top: react_1.css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    top: 32px;\n    left: 50%;\n    transform: translateX(-50%) !important;\n  "])))
};

var container = function container(color, position, width) {
  return react_1.css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: ", ";\n  position: fixed;\n  ", ";\n  padding: 14px 16px 16px 14px;\n  ", ";\n  box-shadow: 0 4px 8px 0 rgba(33, 37, 41, 0.1);\n  color: white;\n  font-weight: 500;\n  font-size: 14px;\n  letter-spacing: -0.4px;\n  white-space: pre-wrap;\n  border-radius: 4px;\n  text-align: left;\n  transition: all 0.15s ease;\n  z-index: var(--z-toast);\n"])), width, positionStyles[position], colorStyles[color]);
};

exports.container = container;
exports.spinner = react_1.css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  margin-right: 4px;\n"])));